import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public _storage: Storage | null = null;
  private readonly isBrowser: boolean;

  constructor(private storage: Storage, @Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.init();
    }
  }

  async init() {
    if (!this.isBrowser) {
      return;
    }
    const storage = await this.storage.create();
    this._storage = storage;
  }
  async get(key: string) {
    if (!this._storage) {
      return null;
    }
    const getdata = await this._storage.get(key);
    return getdata;
  }

  async set(key: string, value: any) {
    if (!this._storage) {
      return value;
    }
    const setdata = await this._storage?.set(key, value);
    return setdata;
  }

  async remove(key: string) {
    if (!this._storage) {
      return null;
    }
    const remove = await this._storage.remove(key);
    return remove;
  }

  async clearStore() {
    if (!this._storage) {
      return null;
    }
    await this._storage.remove('userData');
    const clear = await this._storage.clear();
    return clear;
  }
}
